<template>
	<form
		ref="form"
		class="partnership-marketing-form"
		:action="action"
		method="post"
		@submit="submitForm"
	>
		<div class="row name">
			<div class="col-lg-6">
				<div class="form-floating mb-3">
					<input
						id="first_name"
						v-model="firstName"
						class="form-control"
						data-testid="input-first-name"
						maxlength="40"
						name="first_name"
						placeholder="First Name&ast;"
						type="text"
						v-bind="firstNameProps"
					/>
					<label for="first_name">First Name&ast;</label>
					<div class="invalid-feedback mt-1" data-testid="error-first-name">
						{{ errors.first_name }}
					</div>
				</div>
			</div>
			<div class="col-lg-6">
				<div class="form-floating mb-3">
					<input
						id="last_name"
						v-model="lastName"
						class="form-control"
						data-testid="input-last-name"
						maxlength="80"
						name="last_name"
						placeholder="Last Name&ast;"
						type="text"
						v-bind="lastNameProps"
					/>
					<label for="last_name">Last Name&ast;</label>
					<div class="invalid-feedback mt-1" data-testid="error-last-name">
						{{ errors.last_name }}
					</div>
				</div>
			</div>
		</div>
		<div class="row email">
			<div class="col">
				<div class="form-floating mb-3">
					<input
						id="email"
						v-model="email"
						name="email"
						class="form-control"
						data-testid="input-email"
						maxlength="100"
						placeholder="Email&ast;"
						type="text"
						v-bind="emailProps"
					/>
					<label for="email">Email&ast;</label>
					<div class="invalid-feedback mt-1" data-testid="error-email">{{ errors.email }}</div>
				</div>
			</div>
		</div>
		<div class="row phone title">
			<div class="col-lg-6 phone">
				<div class="form-floating mb-3">
					<input
						id="phone"
						v-model="phone"
						v-maska="phoneMaskaOptions"
						name="phone"
						class="form-control"
						data-testid="input-phone"
						placeholder="Phone"
						type="tel"
						v-bind="phoneProps"
					/>
					<label for="phone">Phone</label>
					<div class="invalid-feedback mt-1" data-testid="error-phone">{{ errors.phone }}</div>
				</div>
			</div>
			<div class="col-lg-6 title">
				<div class="form-floating mb-3">
					<input
						id="title"
						v-model="title"
						name="title"
						class="form-control"
						data-testid="input-title"
						placeholder="Position Title"
						type="text"
					/>
					<label for="title">Position Title</label>
				</div>
			</div>
		</div>
		<div class="row company-name url">
			<div class="col-lg-6 company-name">
				<div class="form-floating mb-3">
					<input
						id="company"
						v-model="company"
						class="form-control"
						data-testid="input-company-name"
						name="company"
						placeholder="Company Name&ast;"
						type="text"
						v-bind="companyProps"
					/>
					<label for="company" class="">Company Name&ast;</label>
					<div class="invalid-feedback mt-1" data-testid="error-company-name">
						{{ errors.company }}
					</div>
				</div>
			</div>
			<div class="col-lg-6 url">
				<div class="form-floating mb-3">
					<input
						id="url"
						v-model="url"
						class="form-control"
						data-testid="input-url"
						name="url"
						placeholder="Website&ast;"
						type="text"
						v-bind="urlProps"
					/>
					<label for="company" class="">Website&ast;</label>
					<div class="invalid-feedback mt-1" data-testid="error-url">
						{{ errors.url }}
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col mb-3">
				<fieldset>
					<legend class="h6 mb-1">Campaign Desired Reach</legend>
					<div class="form-check">
						<Field
							v-slot="{ field }"
							name="00N8V00000P1y35"
							type="checkbox"
							value="1"
							:unchecked-value="undefined"
						>
							<input
								id="00N8V00000P1y35"
								class="form-check-input"
								data-testid="input-national"
								type="checkbox"
								value="1"
								v-bind="field"
							/>
							<label class="form-check-label" for="00N8V00000P1y35">National</label>
						</Field>
					</div>
					<div class="form-check">
						<Field
							v-slot="{ field }"
							name="00N8V00000P1y37"
							type="checkbox"
							value="1"
							:unchecked-value="undefined"
						>
							<input
								id="00N8V00000P1y37"
								class="form-check-input"
								data-testid="input-regional"
								type="checkbox"
								value="1"
								v-bind="field"
							/>
							<label class="form-check-label" for="00N8V00000P1y37">Regional</label>
						</Field>
					</div>
					<div class="form-check">
						<Field
							v-slot="{ field }"
							name="00N8V00000P1y34"
							type="checkbox"
							value="1"
							:unchecked-value="undefined"
						>
							<input
								id="00N8V00000P1y34"
								class="form-check-input"
								data-testid="input-local"
								type="checkbox"
								value="1"
								v-bind="field"
							/>
							<label class="form-check-label" for="00N8V00000P1y34">Local</label>
						</Field>
					</div>
				</fieldset>
			</div>
		</div>

		<div class="row">
			<div class="col mb-3">
				<fieldset>
					<legend class="h6 mb-1">Advertising Area(s) of Interest</legend>
					<div class="form-check">
						<Field
							v-slot="{ field }"
							name="00N8V00000P1y31"
							type="checkbox"
							value="1"
							:unchecked-value="undefined"
						>
							<input
								id="00N8V00000P1y31"
								class="form-check-input"
								data-testid="input-event-sponsor"
								type="checkbox"
								value="1"
								v-bind="field"
							/>
							<label class="form-check-label" for="00N8V00000P1y31">
								Endurance Event Sponsorship/Expo
							</label>
						</Field>
					</div>
					<div class="form-check">
						<Field
							v-slot="{ field }"
							name="00N8V00000P1y32"
							type="checkbox"
							value="1"
							:unchecked-value="undefined"
						>
							<input
								id="00N8V00000P1y32"
								class="form-check-input"
								data-testid="input-magazine"
								type="checkbox"
								value="1"
								v-bind="field"
							/>
							<label class="form-check-label" for="00N8V00000P1y32">
								Experience Life Magazine Print/Digital
							</label>
						</Field>
					</div>
					<div class="form-check">
						<Field
							v-slot="{ field }"
							name="00N8V00000P1y33"
							type="checkbox"
							value="1"
							:unchecked-value="undefined"
						>
							<input
								id="00N8V00000P1y33"
								class="form-check-input"
								data-testid="input-club-exp"
								type="checkbox"
								value="1"
								v-bind="field"
							/>
							<label class="form-check-label" for="00N8V00000P1y33">
								Life Time Club Experience
							</label>
						</Field>
					</div>
					<div class="form-check">
						<Field
							v-slot="{ field }"
							name="00N8V00000P1y3P"
							type="checkbox"
							value="1"
							:unchecked-value="undefined"
						>
							<input
								id="00N8V00000P1y3P"
								class="form-check-input"
								data-testid="input-club-ooh"
								type="checkbox"
								value="1"
								v-bind="field"
							/>
							<label class="form-check-label" for="00N8V00000P1y3P">
								Life Time Club OOH Media
							</label>
						</Field>
					</div>
					<div class="form-check">
						<Field
							v-slot="{ field }"
							name="00N8V00000P1y36"
							type="checkbox"
							value="1"
							:unchecked-value="undefined"
						>
							<input
								id="00N8V00000P1y36"
								class="form-check-input"
								data-testid="input-other"
								type="checkbox"
								value="1"
								v-bind="field"
							/>
							<label class="form-check-label" for="00N8V00000P1y36"> Other </label>
						</Field>
					</div>
				</fieldset>
			</div>
		</div>

		<div class="row">
			<div class="col mb-3">
				<div class="form-floating">
					<textarea
						id="description"
						v-model="description"
						class="form-control"
						data-testid="input-description"
						placeholder="Tell Us More About Your Partnership Interest&ast;"
						name="description"
						v-bind="descriptionProps"
						style="height: 10rem"
					></textarea>
					<label for="description">Tell Us More About Your Partnership Interest&ast;</label>
					<div class="invalid-feedback mt-1" data-testid="error-description">
						{{ errors.description }}
					</div>
				</div>
			</div>
		</div>

		<div class="text-center pt-0">
			<button id="submitForm" class="btn btn-dark" data-testid="btn-submit" type="submit">
				Submit Form
			</button>

			<input type="hidden" name="oid" data-testid="input-oid" :value="authoredContent.oid" />
			<input type="hidden" name="retURL" data-testid="input-ret-url" :value="retUrl" />
			<input type="hidden" name="lead_source" value="Inbound LT Website" />
			<input type="hidden" name="Lead_Origin__c" value="LTPMLTW" />
			<input type="hidden" name="00N1H00000Go5Ga" value="PM_Webform_LT_Master" />
		</div>
	</form>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, ref, type Ref } from 'vue';
import { vMaska } from 'maska/vue';
import { Field, useForm, type PublicPathState } from 'vee-validate';
import { useMaska } from '@/composables/use-maska';
import { getAuthoredContent } from '@/util/getAuthoredContent';
import { sfWebToLead } from '@/util/configs';
import { validateEmail, validateName, validatePhone } from '@/util/validators';
import type { PartnershipMarketingForm } from 'Types/aemui/partnership-marketing-form/partnershipMarketingForm';
import type { SalesforceFormContent } from 'Types/aemui/salesforce-form-content/salesforceFormContent';

const action = sfWebToLead.url;
const form: Ref<HTMLFormElement | null> = ref(null);
const authoredContent: Ref<SalesforceFormContent> = ref({});

onBeforeMount(async () => {
	authoredContent.value = getAuthoredContent<SalesforceFormContent>(
		'aemuiPartnershipMarketingFormScript'
	);
});

const { defineField, errors, submitForm, values, validate } = useForm<PartnershipMarketingForm>({
	validationSchema: {
		first_name: (value: string) => validateName(value, 'Please enter your first name', 40),
		last_name: (value: string) => validateName(value, 'Please enter your last name', 80),
		email: (value: string) => validateEmail(value, 'Please enter your email'),
		phone: (value: string) =>
			!value ? true : validatePhone(value, 'Please enter your phone number'),
		company: (value: string) => (value ? true : 'Please enter your company name'),
		url: (value: string) => (value ? true : 'Please enter your website'),
		description: (value: string) => (value ? true : 'Please enter your partnership interest')
	}
});

function propsHandler(state: PublicPathState, checkTouched = false) {
	const showError = checkTouched
		? state.touched && state.errors.length > 0
		: state.errors.length > 0;
	return { class: showError ? 'is-invalid' : '' };
}

const [firstName, firstNameProps] = defineField('first_name', {
	props: (state) => propsHandler(state)
});

const [lastName, lastNameProps] = defineField('last_name', {
	props: (state) => propsHandler(state)
});

const [email, emailProps] = defineField('email', {
	props: (state) => propsHandler(state, true)
});

const { phoneMaskaOptions } = useMaska();
const [phone, phoneProps] = defineField('phone', {
	props: (state) => propsHandler(state, true)
});

const [title] = defineField('title');

const [company, companyProps] = defineField('company', {
	props: (state) => propsHandler(state)
});

const [url, urlProps] = defineField('url', {
	props: (state) => propsHandler(state)
});

const [description, descriptionProps] = defineField('description', {
	props: (state) => propsHandler(state)
});

const retUrl = computed(
	() =>
		authoredContent.value?.retUrl ??
		'https://www.lifetime.life/partnership-marketing/confirmation.html'
);

defineExpose({
	values,
	validate
});
</script>
